import React, { Component, useRef, useEffect } from 'react';
import { connect } from 'react-redux';
import cn from 'classnames';
import styles from './Profile.scss';
import Footer from 'components/Footer';
import ProfileForm from './ProfileForm';
import SubscriptionBar from 'components/Payments/SubscriptionBar';
import { USER_ROLE } from 'constants';
import { getUserRole } from 'utils';
import withObservePayments from 'decorators/withObservePayments';
import tracker from '../../services/tracker';
import { withTranslation } from 'react-i18next';

const ProfileEvents = React.memo(({ profile }) => {
  const isSent = useRef(false);
  const { firstName, lastName, phone, tariff } = profile;

  useEffect(() => {
    if (!firstName || !lastName || !phone) {
      return;
    }

    if (isSent.current) {
      return;
    }

    isSent.current = true;

    const { countDay, datePay } = tariff;

    tracker.sendEvent('SUBSCRIPTION', {
      телефон: phone ? `${phone[0]} (${phone.slice(1, 4)}) ${phone.slice(4, 7)} ${phone.slice(7, 9)} ${phone.slice(9)}` : '',
      имя_пользователя: `${firstName} ${lastName}`,
      дата_подписки: datePay ? datePay.slice(0, 10).split('-').reverse().join('/') : '',
      оставшиеся_дни: countDay
    });
  }, [firstName, lastName, phone]);

  return null;
});

@withObservePayments
class Profile extends Component {
  render() {
    const { roleName, agencyId, profile, t } = this.props;
    const role = getUserRole(profile);
    const hasNoPermission = (roleName && agencyId && roleName !== 'admin' && roleName !== 'owner');
    return (
      <div className={styles.ProfileWrap}>
        <div className={cn(styles.Profile, { [styles.HasNotification]: hasNoPermission })}>
          {
            hasNoPermission &&
            <div className={styles.PermissionNotification}>
              {t('components.profile.profile.noPermission')}
            </div>
          }
          <div className={styles.Container}>
            <div className={styles.Title}>
              {t('components.profile.profile.title')}
            </div>
            {role === USER_ROLE.INDIVIDUAL && <SubscriptionBar className={styles.SubscriptionBarInProfile} />}
            <ProfileForm />
          </div>
        </div>
        <ProfileEvents profile={profile} />
        <Footer />
      </div>
    );
  }
}

export default connect(
  ({ profile }) => ({
    roleName: profile && profile.roleName,
    agencyId: profile && profile.agencyId,
    profile
  })
)(withTranslation()(Profile));



// WEBPACK FOOTER //
// ./src/components/Profile/Profile.js